export default __webpack_public_path__ + "static/media/icon05.0c0b9832.png";